import React from 'react';
import { createRoot } from 'react-dom/client';
import { ApolloClient, InMemoryCache } from '@apollo/client';
import { HttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import store, { history, persistor } from './store';
import './css/fonts';
import './css/bootstrap.css';
import './css/bootstrap-float-label.min.css';
import './css/et-custom.css';
import './css/flex-layout-utils.css';
import './css/react-datetime.css';
import './index.css';
import './css/et-print.css';
import AppRoot from './AppRoot';
// $FlowFixMe
import { unregister } from './registerServiceWorker';
import appSagas from './containers/App/sagas';
import prospectProfileSagas from './containers/ProspectProfile/sagas';
import workOrderSagas from './containers/WorkOrder/sagas';
import affordableQualificationHistoryTabSagas from './containers/AffordableQualificationHistoryTab/sagas';
import applicationProfileSagas from './containers/ApplicationProfile/sagas';
import residentProfileSagas from './containers/ResidentProfile/sagas';
import manageProspectsSagas from './containers/ManageProspects/sagas';
import createUserSagas from './containers/CreateUser/sagas';
import editUserSagas from './containers/EditUser/sagas';
import peopleProfileSagas from './containers/PeopleProfile/sagas';
import resetPasswordSagas from './containers/ResetPassword/sagas';
import loginSagas from './containers/Login/sagas';
import forgotPasswordSagas from './containers/ForgotPassword/sagas';
import createRoleSagas from './containers/CreateRole/sagas';
import editRoleSagas from './containers/EditRole/sagas';
import homeSagas from './containers/Home/sagas';
import manageApplicationsSagas from './containers/ManageApplications/sagas';
import managePriorResidentsSagas from './containers/ManagePriorResidents/sagas';
import manageDelinquenciesSagas from './containers/ManageDelinquency/sagas';
import createApplicationSagas from './containers/CreateApplication/sagas';
import manageDocumentsSagas from './containers/ManageDocuments/sagas';
import shortLeaseApplicationSagas from './containers/ShortLeaseApplication/sagas';
import editProspectHouseholdSagas from './containers/EditProspectHousehold/sagas';
import manageWorkOrdersSagas from './containers/ManageWorkOrders/sagas';
import primaryLeaseApplicationSagas from './containers/PrimaryLeaseApplication/sagas';
import secondaryLeaseApplicationSagas from './containers/NonPrimaryLeaseApplication/sagas';
import editApplicationHouseholdSagas from './containers/EditApplicationHousehold/sagas';
import createResidentSagas from './containers/CreateResident/sagas';
import createCommercialTenantSagas from './containers/CreateCommercialTenant/sagas';
import miscTransactionSagas from './containers/ManageMiscTransactions/sagas';
import manageDepositsSagas from './containers/ManageDeposits/sagas';
import viewBankDepositSagas from './containers/ViewBankDeposit/sagas';
import createMiscTransactionSagas from './containers/ManageMiscTransactions/CreateMiscTransaction/sagas';
import manageUnitAvailabilitySagas from './containers/ManageUnitAvailability/sagas';
import leaseDataTabSagas from './containers/LeaseDataTab/sagas';
import ledgerSagas from './containers/Ledger/sagas';
import viewPropertySagas from './containers/ViewProperty/sagas';
import createTransactionSagas from './components/CreateTransaction/sagas';
import getChargeBatchSagas from './containers/CreateChargeBatch/sagas';
import createChargeBatchSagas from './containers/CreateChargeBatch/CreateChargeBatchForm/sagas';
import viewUnitSagas from './containers/ViewUnit/sagas';
import householdVehiclesSagas from './containers/HouseholdVehicles/sagas';
import monthEndCloseSagas from './containers/MonthEndClose/sagas';
import expiringLeasesSaga from './containers/ManageLeaseExpirations/sagas';
import manageUndepositedPaymentsSagas from './containers/ManageUndepositedPayments/sagas';
import finalAccountStatementSagas from './containers/FinalAccountStatement/sagas';
import qualificationSagas from './containers/QualificationForms/sagas';
import viewUnitEditFeesSagas from './containers/ViewUnit/EditFees/sagas';
import errorBoundarySagas from './containers/ErrorBoundary/sagas';
import editResidentHouseholdSagas from './containers/EditResidentHousehold/sagas';
import reportSagas from './containers/ManageReports/sagas';
import viewCommunicationSagas from './containers/ViewCommunications/sagas';
import leasingActivitySagas from './containers/LeasingActivity/sagas';
import overviewSagas from './containers/Overview/sagas';
import manageFloorPlansSagas from './containers/ManageFloorPlans/sagas';
import recertificationApplicationSagas from './containers/RecertificationApplication/sagas';
import manageCommunicationsSagas from './containers/ManageCommunications/sagas';
import portfolioSagas from './containers/Portfolio/sagas';
import transferResidentsagas from './containers/ResidentProfile/ResidentTransfer/sagas';
import propertyPortalSagas from './containers/ManageProperties/PropertyPortalModal/sagas';
import tenantSagas from './containers/Tenant/sagas';
import i18n from './i18n';
import { getCookie } from './utils/cookie';
import TagManager from 'react-gtm-module';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import { selectProperty } from './containers/App/actions';
import { parsePropertyIdFromPath } from './utils/navigation-helpers';
import {
  initializeDatadog,
  addFeatureFlagEvaluation,
  setDatadogUser,
} from './utils/datadog';
import {
  initializeMsal,
  isAzureAuthConfigured,
} from './config/azureAuthConfig';

if (import.meta.env.MODE === 'production') {
  require('loggly-jslogger');
}

const authLink = setContext((_, { headers }) => {
  const authToken = getCookie('session_id');
  const newHeaders = {
    ...headers,
    authorization: authToken ? `Bearer ${authToken}` : null,
  };
  return {
    headers: newHeaders,
  };
});

const httpLink = new HttpLink({
  uri: import.meta.env.REACT_APP_PAYMENTS_API_URL,
});

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: authLink.concat(httpLink),
});

// $FlowFixMe
appSagas.map(store.runSaga);
// $FlowFixMe
prospectProfileSagas.map(store.runSaga);
// $FlowFixMe
workOrderSagas.map(store.runSaga);
// $FlowFixMe
affordableQualificationHistoryTabSagas.map(store.runSaga);
// $FlowFixMe
applicationProfileSagas.map(store.runSaga);
// $FlowFixMe
residentProfileSagas.map(store.runSaga);
// $FlowFixMe
manageProspectsSagas.map(store.runSaga);
// $FlowFixMe
createUserSagas.map(store.runSaga);
// $FlowFixMe
editUserSagas.map(store.runSaga);
// $FlowFixMe
peopleProfileSagas.map(store.runSaga);
// $FlowFixMe
resetPasswordSagas.map(store.runSaga);
// $FlowFixMe
loginSagas.map(store.runSaga);
// $FlowFixMe
forgotPasswordSagas.map(store.runSaga);
// $FlowFixMe
createRoleSagas.map(store.runSaga);
// $FlowFixMe
editRoleSagas.map(store.runSaga);
// $FlowFixMe
homeSagas.map(store.runSaga);
// $FlowFixMe
manageApplicationsSagas.map(store.runSaga);
// $FlowFixMe
createApplicationSagas.map(store.runSaga);
// $FlowFixMe
manageDocumentsSagas.map(store.runSaga);
// $FlowFixMe
shortLeaseApplicationSagas.map(store.runSaga);
// $FlowFixMe
editProspectHouseholdSagas.map(store.runSaga);
// $FlowFixMe
manageWorkOrdersSagas.map(store.runSaga);
// $FlowFixMe
primaryLeaseApplicationSagas.map(store.runSaga);
// $FlowFixMe
secondaryLeaseApplicationSagas.map(store.runSaga);
// $FlowFixMe
editApplicationHouseholdSagas.map(store.runSaga);
// $FlowFixMe
createResidentSagas.map(store.runSaga);
// $FlowFixMe
createCommercialTenantSagas.map(store.runSaga);
// $FlowFixMe
manageUnitAvailabilitySagas.map(store.runSaga);
// $FlowFixMe
leaseDataTabSagas.map(store.runSaga);
// $FlowFixMe
ledgerSagas.map(store.runSaga);
// $FlowFixMe
viewPropertySagas.map(store.runSaga);
// $FlowFixMe
createTransactionSagas.map(store.runSaga);
// $FlowFixMe
miscTransactionSagas.map(store.runSaga);
// $FlowFixMe
getChargeBatchSagas.map(store.runSaga);
// $FlowFixMe
createChargeBatchSagas.map(store.runSaga);
// $FlowFixMe
monthEndCloseSagas.map(store.runSaga);
// $FlowFixMe
manageDepositsSagas.map(store.runSaga);
// $FlowFixMe
viewBankDepositSagas.map(store.runSaga);
// $FlowFixMe
createMiscTransactionSagas.map(store.runSaga);
// $FlowFixMe
viewUnitSagas.map(store.runSaga);
// $FlowFixMe
householdVehiclesSagas.map(store.runSaga);
// $FlowFixMe
managePriorResidentsSagas.map(store.runSaga);
// $FlowFixMe
manageDelinquenciesSagas.map(store.runSaga);
// $FlowFixMe
expiringLeasesSaga.map(store.runSaga);
// $FlowFixMe
manageUndepositedPaymentsSagas.map(store.runSaga);
// $FlowFixMe
finalAccountStatementSagas.map(store.runSaga);
// $FlowFixMe
qualificationSagas.map(store.runSaga);
// $FlowFixMe
viewUnitEditFeesSagas.map(store.runSaga);
// $FlowFixMe
errorBoundarySagas.map(store.runSaga);
// $FlowFixMe
editResidentHouseholdSagas.map(store.runSaga);
// $FlowFixMe
reportSagas.map(store.runSaga);
// $FlowFixMe
overviewSagas.map(store.runSaga);
// $FlowFixMe
manageFloorPlansSagas.map(store.runSaga);
// $FlowFixMe
recertificationApplicationSagas.map(store.runSaga);
// $FlowFixMe
leasingActivitySagas.map(store.runSaga);
// $FlowFixMe
viewCommunicationSagas.map(store.runSaga);
// $FlowFixMe
manageCommunicationsSagas.map(store.runSaga);
// $FlowFixMe
portfolioSagas.map(store.runSaga);
// $FlowFixMe
transferResidentsagas.map(store.runSaga);
// $FlowFixMe
propertyPortalSagas.map(store.runSaga);
// $FlowFixMe
tenantSagas.map(store.runSaga);

// Initialize Datadog RUM BEFORE React app initialization
// This ensures we capture all early errors, resources, and user interactions
initializeDatadog();

const tagManagerArgs = {
  // $FlowFixMe
  gtmId: `${import.meta.env.REACT_APP_TAG_MANAGER_ID}`,
};

TagManager.initialize(tagManagerArgs);
(async () => {
  if (isAzureAuthConfigured()) {
    await initializeMsal();
  }

  const LDProvider = await asyncWithLDProvider({
    clientSideID: `${import.meta.env.REACT_APP_LAUNCHDARKLY_TOKEN}`,
    context: {
      kind: 'user',
      key: 'fortressUser',
      hostname: window.location.hostname,
    },
    options: {
      inspectors: [
        {
          type: 'flag-used',
          name: 'dd-inspector',
          method: (key, detail) => {
            addFeatureFlagEvaluation(key, detail.value);
          },
        },
      ],
    },
  });
  const rootElement = document.getElementById('root');

  if (!rootElement) {
    throw new Error('Unable to find root element.');
  }

  const root = createRoot(rootElement);

  root.render(
    React.createElement(AppRoot, {
      client,
      LDProvider,
      store,
      persistor,
      history,
      messages: i18n.messages,
      onBeforeLift: () => {
        const storeSnapshot = store.getState();
        const propertyId = parsePropertyIdFromPath(history.location.pathname);
        const userProperties =
          storeSnapshot?.app?.currentUser?.user?.properties ?? [];
        const selectedPropertyFromURL = userProperties.find(
          (userProperty) => userProperty.id === propertyId,
        );
        store.dispatch(selectProperty(selectedPropertyFromURL));

        // Re-identify the user in Datadog on every page load.
        // setDatadogUser is only called during the login saga, so users
        // with a persisted session (page refresh, new tab, return visit)
        // would otherwise appear as anonymous in Datadog.
        const persistedUser = storeSnapshot?.app?.currentUser?.user;
        if (persistedUser) {
          setDatadogUser(persistedUser);
        }
      },
    }),
  );
  unregister();
})();
